import { getExportConfigs } from '@anduin/shared';
import { BaseExportParams, GridApi, ShouldRowBeSkippedParams } from 'ag-grid-community';
import { OutboundEmailRow } from '../../../models';

export const SENT_AT_COLUMN_ID = 'sentAt';

export function shouldSkipSentExportRow({ node }: ShouldRowBeSkippedParams): boolean {
  return !!node.group || !node.data;
}

export function getSentTableExportParams(gridApi: GridApi): BaseExportParams {
  const baseParams = getExportConfigs(gridApi);
  const otherColumnKeys = (baseParams.columnKeys ?? []).filter((key) => key !== SENT_AT_COLUMN_ID);
  return {
    ...baseParams,
    columnKeys: [SENT_AT_COLUMN_ID, ...otherColumnKeys],
    shouldRowBeSkipped: shouldSkipSentExportRow,
  };
}

// Mirrors the live table: a row expands into recipient children only when isServerSideGroup() marks it a group
export function flattenOutboundEmailRows(rows: OutboundEmailRow[]): OutboundEmailRow[] {
  return rows.flatMap((row) => {
    const recipientDetails = row.recipientDetails ?? [];
    if (row.hasChildren === false || recipientDetails.length <= 1) {
      return [row];
    }

    return recipientDetails.map((detail) => ({
      ...row,
      ...detail,
      recipients: (detail as OutboundEmailRow & { recipient?: string }).recipient,
      hasChildren: false,
      level: 1,
    }));
  });
}
